import React from "react";
import {observer} from "mobx-react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper";
import styled from "styled-components";
import {MonthModel} from "../../../services/time/month.model";
import {FlightsDatesSelector} from "../../../services/flight-search/dates-selection/flights-dates-selector";
import {FlightCalendarMonthComponent} from "../flight-calendar-month.component";

const SwiperContainerBox = styled.div`
    min-height: 200px;
    width: 100%;
    .swiper-button-prev {
      color: ${props => props.theme.colors.primary};
      padding-right: 12px;
    }
    .swiper-button-next {
      color: ${props => props.theme.colors.primary};
      padding-left: 12px;
    }

    .swiper-slide {
       padding: 0 35px 0 35px;
       display: flex;
       align-items: center;
       justify-content: center;
    }
`

interface CalendarsInSwiperComponentProps {
    flightsDatesSelector: FlightsDatesSelector;
    onDateClicked: (date: Date) => void;
    renderMessages: () => React.ReactElement | null;
}

export const CalendarsInSwiperComponent: React.FC<CalendarsInSwiperComponentProps> = observer((props) => {

    const renderOneSlide = (month: MonthModel) => {
        return (
            <SwiperSlide key={month.key}>
                <FlightCalendarMonthComponent month={month}
                                              onDateClicked={props.onDateClicked}
                                              flightsDatesSelector={props.flightsDatesSelector}/>
            </SwiperSlide>
        );
    }

    const renderSwiper = () => {
        const messages = props.renderMessages();
        if(messages) {
            return messages;
        }

        return (
            <Swiper navigation={true}
                    modules={[Navigation]}
                    spaceBetween={0}
                    slidesPerView={2}>
                {props.flightsDatesSelector.flightsScheduledMonths.map(renderOneSlide)}

            </Swiper>
        );
    }

    return (
        <SwiperContainerBox>
            {renderSwiper()}
        </SwiperContainerBox>

    )
});
